import {
  HEX_273D58,
  HEX_292D38,
  HEX_3D526B,
  HEX_3E4B68,
  HEX_646A7E,
  HEX_656F7B,
  HEX_66AAFF,
  HEX_ADB5C7,
  HEX_CED7E2,
  HEX_E6444E,
  HEX_ECF4FF,
  HEX_FCFDFE,
  HEX_FFFFFF,
} from '@tanium/colors';
import {
  Background1,
  defineColor,
  Foreground2,
  Link,
  StatusNegative,
  Text1,
  Text2,
} from '@tanium/react-theme-definition';

export const ContainerFill = Background1;

export const MonthHeaderText = defineColor([HEX_292D38, HEX_FCFDFE]);
export const DaysOfWeekHeaderText = Text1;
export const YearHeaderText = defineColor([HEX_646A7E, HEX_FCFDFE]);

export const Icon = Link;

export const DayFill = defineColor([HEX_FFFFFF, HEX_3D526B]);
export const DayBorder = defineColor([HEX_CED7E2, HEX_3D526B]);
export const DayText = Text2;
export const DayFillHover = defineColor([HEX_ECF4FF, HEX_66AAFF]);
export const DayFillActive = defineColor([HEX_3E4B68, HEX_66AAFF]);
export const DayTextActive = () => HEX_FFFFFF;
export const DayFillSelected = Foreground2;
export const DayFillNotInMonth = defineColor([HEX_FFFFFF, HEX_273D58]);
export const DayTextDisabled = defineColor([HEX_ADB5C7, HEX_656F7B]);
export const DayTextNotInMonth = defineColor([HEX_CED7E2, HEX_656F7B]);
export const DayBorderNotInMonth = defineColor([HEX_CED7E2, HEX_273D58]);
export const MinMaxHighlightCorner = defineColor([HEX_E6444E, HEX_656F7B]);

export const ErrorFill = StatusNegative;
export const ErrorText = () => HEX_FCFDFE;
